<template>
  <v-layout>

    <v-flex xs6>
      <gmap :loading="loadingPrenotazioni || loadingMarkers" ref="gmap">
        <gmap-route v-for="route in filteredRoutes" :key="route.id" :points="route.points" :color="route.color" :legs.sync="route.legs">

          <gmap-marker v-for="marker in route.points" :key="marker.id" :position="marker.position" :label="'' + marker.index" :color="marker.color">
            <div class="body-2 py-1">
              <span class="title font-weight-bold">{{ marker.ora_controllo }}</span>
              <span class="title ml-2">{{ marker.agricoltore.ragione_sociale }}</span>
              <div class="mt-1" v-if="marker.tecnico">
                <b>{{ $t('label.tecnico') }}:</b>
                <span class="ml-2">{{ marker.tecnico.nome_cognome }}</span>
              </div>
            </div>
          </gmap-marker>

        </gmap-route>
      </gmap>
    </v-flex>

    <v-flex xs6 class="px-0">
      <v-flex xs12 class="px-0">

        <div style="display: flex">

          <v-btn color="white" class="elevation-3" fab small @click="onPrevDayClick">
            <v-icon>chevron_left</v-icon>
          </v-btn>

          <date-picker v-model="selectedDate" :clearable="false" class="font-weight-bold text-xs-center round"  :locale="$i18n.locale" solo/>

          <tecnici-select v-model="selectedTecnico" :placeholder="$t('prenotazioni.label.tecnico')" class="font-weight-bold round mb-1 ml-1" solo/>

          <v-btn color="white" class="elevation-3" fab small @click="onNextDayClick">
            <v-icon>chevron_right</v-icon>
          </v-btn>

        </div>

      </v-flex>

      <v-flex xs12 class="scrollable-flex scroll-y px-0">

        <prenotazioni-list
          ref="prenotazioniList"
          class="clear-both"
          :loading="loadingPrenotazioni"
          :prenotazioni="filteredPrenotazioniWithDistance"
          show-tecnico
          @click:item="centerMapByMarker"
          @change="fetchPrenotazioni"/>

      </v-flex>

    </v-flex>

  </v-layout>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker'
import TecniciSelect from '@/components/inputs/TecniciSelect'
import PrenotazioniList from '@/components/PrenotazioniList'
import Gmap from '@/components/gmap/Gmap'
import GmapMarker from '@/components/gmap/GmapMarker'
import GmapRoute from '@/components/gmap/GmapRoute'

export default {
    name: 'PrenotazioniMap',
    components: { GmapRoute, DatePicker, TecniciSelect, PrenotazioniList, Gmap, GmapMarker },
    data () {
        return {
            loadingPrenotazioni: false,
            loadingMarkers: false,
            prenotazioni: [],
            routes: [], //  Raggruppati per tecnico
            selectedDate: this.$utils.date.getSqlToday(),
            selectedTecnico: null
        }
    },
    created () {
        window.addEventListener('keyup', this.onKeyUp)
    },
    beforeDestroy () {
        window.removeEventListener('keyup', this.onKeyUp)
    },
    watch: {
        selectedDate: {
            handler: 'fetchPrenotazioni',
            immediate: true
        }
    },
    computed: {
        filteredPrenotazioniWithDistance () {
            if (!this.selectedTecnico) {
                return this.prenotazioni
            } else {
                let result = []
                let filteredPrenotazioni = this.prenotazioni.filter(prenotazione => prenotazione.id_tecnico === this.selectedTecnico)
                for (let i = 0; i < filteredPrenotazioni.length; i++) {
                    let pren = filteredPrenotazioni[i]
                    result.push(pren)
                    if (i + 1 < filteredPrenotazioni.length) {
                        //  Se non è l'ultimo elemento, aggiungo i dati sulla distanxa dalla prenotazione successiva
                        let availableTimeValue = this.$utils.time.toSeconds(filteredPrenotazioni[i + 1].ora_controllo) - this.$utils.time.toSeconds(pren.ora_controllo)
                        //  Se il tecnico è settato, avrò un solo elemento in routes, che è il percorso che mi interessa con legs
                        if (this.filteredRoutes[0] && this.filteredRoutes[0].legs[i]) {
                            result.push({
                                travelDuration: this.filteredRoutes[0].legs[i].duration,
                                travelDistance: this.filteredRoutes[0].legs[i].distance,
                                availableTime: {
                                    text: this.$utils.time.toString(availableTimeValue),
                                    value: availableTimeValue
                                },
                                showWarning: this.filteredRoutes[0].legs[i].duration.value > availableTimeValue
                            })
                        }
                    }
                }
                return result
            }
        },
        filteredRoutes () {
            return !this.selectedTecnico ? this.routes : this.routes.filter(route => route.id === this.selectedTecnico)
        }
    },
    methods: {
        onKeyUp (e) {
            if (e.key === 'ArrowLeft') this.onPrevDayClick()
            else if (e.key === 'ArrowRight') this.onNextDayClick()
        },
        onPrevDayClick () {
            this.selectedDate = this.$utils.date.toSql(this.$utils.date.addDays(this.selectedDate, -1))
        },
        onNextDayClick () {
            this.selectedDate = this.$utils.date.toSql(this.$utils.date.addDays(this.selectedDate, 1))
        },
        centerMapByMarker (id) {
            let findMarker = (id) => {
                for (let route of this.filteredRoutes) {
                    for (let marker of route.points) {
                        if (marker.id === id) return marker
                    }
                }
                return null
            }

            let marker = findMarker(id)
            if (marker !== null) {
                this.$refs.gmap.setCenter(marker.position)
            }
        },
        fetchPrenotazioni () {
            this.loadingPrenotazioni = true
            this.$api.prenotazioni.get({ to: this.selectedDate, from: this.selectedDate }).then(response => {
                //  Per avere un colore diverso per ogni tecnico asseganto e le prenotazioni in ordine crescente di orario
                this.prenotazioni = response.data.items.map((prenotazione, index) => ({
                    ...prenotazione,
                    index: index + 1,
                    color: prenotazione.id_tecnico ? this.$utils.getMarkerColor(prenotazione.id_tecnico) : '#3c4043' // impostato il colore
                }))
                this.loadingPrenotazioni = false
                this.fetchMarkersPosition()
            }).catch(e => {
                this.loadingPrenotazioni = false
                this.$snackbar.showServerError(e)
            })
        },
        fetchMarkersPosition () {
            this.routes = []
            if (this.prenotazioni.length > 0) {
                this.loadingMarkers = true
                let requests = []
                for (let pren of this.prenotazioni) {
                    requests.push(this.$api.indirizzo.resolveGmapAddress(this.$utils.formatAddress(pren.nome_nazione, pren.nome_regione, pren.sigla_provincia, pren.nome_comune, pren.cap, pren.frazione, pren.via, pren.numero_civico)))
                }
                Promise.all(requests).then(responses => {
                    this.loadingMarkers = false
                    for (let i = 0; i < responses.length; i++) {
                        //  Inserisco le coordinate ottenute raggruppanole per id tecnico, in modo da poter mostrare il percorso tra i vari punti
                        let index = this.routes.findIndex(route => route.id === this.prenotazioni[i].id_tecnico)
                        let newMarker = {
                            ...this.prenotazioni[i],
                            agricoltore: this.$store.getters.getAgricoltoreById(this.prenotazioni[i].id_agricoltore),
                            tecnico: this.$store.getters.getTecnicoById(this.prenotazioni[i].id_tecnico),
                            position: responses[i].data.results[0].geometry.location
                        }
                        if (index === -1) {
                            this.routes.push({
                                id: this.prenotazioni[i].id_tecnico,
                                color: this.prenotazioni[i].color,
                                legs: [],
                                points: [newMarker]
                            })
                        } else {
                            this.routes[index].points.push(newMarker)
                        }
                    }
                }).catch(e => {
                    this.loadingMarkers = false
                    this.$snackbar.showServerError(e)
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>

  #progress {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin-top: 0;
  }

  .scrollable-flex {
    height: calc(100% - 54px);
  }
</style>
